import { IAppState, IDateRangeType } from '../types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@config/store';
import { getDefaultDateRange } from '@utils/functions';

const initialState: IAppState = {
    dateRange: getDefaultDateRange(),
    loading: 'idle',
    error: null,
};

const appSlice = createSlice({
    name: '@@app',
    initialState,
    reducers: {
        setDateRange: (
            state: IAppState,
            { payload }: PayloadAction<IDateRangeType>
        ) => {
            state.dateRange = payload;
        },
        resetDateRange: (state: IAppState) => {
            state.dateRange = getDefaultDateRange();
        },
    },
});

export const { setDateRange, resetDateRange } = appSlice.actions;
export const appReducer = appSlice.reducer;

export const appSelect = (state: RootState) => state.app;
